// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__2aWx6"};